/**
 * @file Module to create Group Button component.
 */

/**
 * Class representing a group.
 */
export class GroupButton {

  /**
   * Setup group properties.
   * @param {HTMLElement} element - The DOM element of the group.
   */
  constructor(element) {
    this.dom = {
      group: element,
      buttons: element.querySelectorAll('.btn')
    };

    this.listeners = {
      click: (evt) => this._toggle(evt)
    };
  }

  /**
   * Initialize the group.
   * @public
   */
  init() {
    this._addEventListeners();
  }

  /**
   * Destroy the group and associated events.
   * @public
   */
  destroy() {
    this._removeEventListeners();
  }

  /**
   * Add event listeners.
   * @private
   */
  _addEventListeners() {
    this.dom.group.addEventListener('click',  this.listeners.click);
  }

  /**
   * Remove event listeners.
   * @private
   */
  _removeEventListeners() {
    this.dom.group.removeEventListener('click',  this.listeners.click);
  }

  /**
   * Toggle the button.
   * @public
   */
  _toggle(evt) {
    if (evt.target.classList.contains('btn')){
      this.dom.buttons.forEach((item) => item.classList[evt.target === item ? 'toggle' : 'remove']('active'));
    }
  }
}
